import { render, staticRenderFns } from "./ReportCompanyMealsTakenMonthlyOrders.vue?vue&type=template&id=19b0548b"
import script from "./ReportCompanyMealsTakenMonthlyOrders.vue?vue&type=script&lang=js"
export * from "./ReportCompanyMealsTakenMonthlyOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports